import React from 'react';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { ColorKey } from './AnalystRatingsCharts';
import AnalystRatingBar, { AnalystRatingBarData } from './AnalystRatingBar';

const AnalystRatings = ({ ratingsByMonthWithCounts }) => {
  const { i18n } = useTranslation('quote');
  const mockDataRatingsByMonthWithCounts = generateMockRatingsByMonthWithCounts(5, i18n.language);
  return (
    <div className="analyst-ratings-count card flex-grow">
      <h6 className="font-bold mb-4">Analyst Ratings</h6>
      {/* {Object.keys(ratingsByMonthWithCounts).length === 0 && <div>No data available</div>} */}
      <div className="flex flex-col gap-2">
        {ratingsByMonthWithCounts.length === 0 &&
          mockDataRatingsByMonthWithCounts.map(rating => (
            <div className="flex items-center justify-between" key={rating.date}>
              <AnalystRatingBar placeholder={true} type="horizontal" {...rating} />
            </div>
          ))}
        {Object.keys(ratingsByMonthWithCounts).map(month => (
          <div className="flex items-center justify-between" key={month}>
            <AnalystRatingBar type="horizontal" {...ratingsByMonthWithCounts[month]} />
          </div>
        ))}
      </div>
      <ColorKey />
    </div>
  );
};

export const generateMockRatingsByMonthWithCounts = (monthsBack: number, language = 'en'): AnalystRatingBarData[] => {
  const currentDate = DateTime.now();
  const ratingsByMonthWithCounts: {
    date: string;
    ratingBuyCount: number;
    ratingCountTotal: number;
    ratingHoldCount: number;
    ratingSellCount: number;
    ratingStrongBuyCount: number;
    ratingStrongSellCount: number;
  }[] = [];

  const generateLeadingUpNumbers = (value: number) => {
    return Array.from({ length: value }, (_, index) => index);
  };

  const leadingUpNumbers = generateLeadingUpNumbers(monthsBack).reverse();
  leadingUpNumbers.forEach(month => {
    const date = currentDate.minus({ months: month });
    ratingsByMonthWithCounts.push({
      date: date.setLocale(language).toFormat('LLL/yyyy'),
      ratingBuyCount: 0,
      ratingCountTotal: 0,
      ratingHoldCount: 0,
      ratingSellCount: 0,
      ratingStrongBuyCount: 0,
      ratingStrongSellCount: 0,
    });
  });
  return ratingsByMonthWithCounts;
};

export default AnalystRatings;
